import React, { useState } from 'react';
import AgentExecutorDetail from '../RunStatusLog/components/AgentExecutorDetail';
import AgentDetail from '../AgentDetail';
import ModalWarning from 'Common/Components/ModalWarning';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { closeModal } from 'store/modals/actions';
import { MODAL_AGENT_TRIGGER_WARNING } from 'store/modals/modals';
import RecordsRepresentation from './RecordsRepresentation';
import { Wrapper } from './styled';
import SuccessPopup from 'Common/Components/SuccessPopup';
import { clearSuccessMessage } from 'store/Agents/actions';
import { selectAgentSuccess } from 'store/Agents/selectors';

const Content = ({ showGridView, selectedTab, showAgentDetail, showTriggerWarning }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [triggerWarning, setTriggerWarning] = useState('');
  const warningMessage = triggerWarning ? intl.formatMessage({ id: `agent.runAgent.warning.${triggerWarning}` }) : '';
  const warningTitle = intl.formatMessage({ id: 'agent.runAgent.warning.title' });
  const successMessage = useSelector(selectAgentSuccess);

  const closeTriggerWarning = () => {
    dispatch(closeModal(MODAL_AGENT_TRIGGER_WARNING));
    setTriggerWarning('');
  };

  return (
    <Wrapper>
      <RecordsRepresentation showGridView={ showGridView } selectedTab={ selectedTab } />
      <AgentExecutorDetail />
      {showAgentDetail && <AgentDetail setTriggerWarning={ setTriggerWarning } /> }
      {showTriggerWarning ? <ModalWarning onCloseCallback={ closeTriggerWarning } title={ warningTitle } description={ warningMessage } /> : null}
      {successMessage && <SuccessPopup message={ successMessage } close={ () => dispatch(clearSuccessMessage()) } /> }
    </Wrapper>
  );
};

export default Content;
